module.exports = __webpack_public_path__ + "4e85ee3ed8c0cdbf98f5ad53d32f4821.svg";